import {useMemo} from 'react';

import {useOverallInfo} from '@components/_context';
import {Modality, MODALITY} from '@domain/model/Account/Subscription/Subscription';

type CurrentPlanReturn = {
  day: number | undefined;
  modality: Modality;
  isOnDemand: boolean;
};

export const useCurrentPlan = (): CurrentPlanReturn => {
  const {subscription} = useOverallInfo();
  const {modality = MODALITY.ON_DEMAND, lkDay} = subscription;

  return useMemo(() => {
    return {
      day: lkDay,
      modality,
      isOnDemand: modality === MODALITY.ON_DEMAND,
    };
  }, [modality, lkDay]);
};
